const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const authService = {
  setToken(token) {
    if (token) {
      // Stocker uniquement dans un cookie sécurisé
      document.cookie = `auth_token=${token}; path=/; secure; samesite=strict; max-age=7200`; // expire dans 2h
    } else {
      document.cookie = 'auth_token=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
  },

  getToken() {
    return document.cookie
      .split('; ')
      .find(row => row.startsWith('auth_token='))
      ?.split('=')[1];
  },

  async login(email, password) {
    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Email ou mot de passe incorrect');
      }
      
      if (!data.access_token) {
        throw new Error('Réponse invalide du serveur');
      }

      this.setToken(data.access_token);
      return data.user;
    } catch (error) {
      console.error('Erreur login:', error);
      throw error;
    }
  },

  async getCurrentUser() {
    try {
      const token = this.getToken();
      if (!token) return null;

      const response = await fetch(`${API_BASE_URL}/me`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });

      if (!response.ok) {
        this.setToken(null);
        return null;
      }

      const data = await response.json();
      if (!data.user) {
        this.setToken(null);
        return null;
      }
      
      return data.user;
    } catch (error) {
      console.error('Erreur getCurrentUser:', error);
      this.setToken(null);
      return null;
    }
  },

  async logout() {
    try {
      const token = this.getToken();
      if (!token) return true;

      const response = await fetch(`${API_BASE_URL}/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': `Bearer ${token}`
        },
        credentials: 'include'
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erreur lors de la déconnexion');
      }

      this.setToken(null);
      return true;
    } catch (error) {
      console.error('Erreur logout:', error);
      this.setToken(null);
      throw error;
    }
  }
}; 